import {connect} from '@modifi/redux'

import CookieBar from './CookieBar'
import {selectExtraLinks} from '../../../data/navigation'

const mapStateToProps = state => ({
  extraLinks: selectExtraLinks(state),
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(CookieBar)
